import getConfig from 'next/config';
import useFetch from 'shared/hooks/useFetch';
import { useUnleash } from '@/hooks/unleash';
import type { ExtraHotelData, ExtraHotelDataRecord } from '@/server/integration/extraHotelDataResponseTypes';
import { extraHotelDataQueryParams } from '@/utils/fetch/extraHotelDataFetcher';
import { hasExtraHotelData } from '@/utils/integration/providers';

const { publicRuntimeConfig } = getConfig();

export const useExtraHotelDataAPI = (hotel: string): ExtraHotelData | undefined => {
    const unleash = useUnleash();

    const { data, error } = useFetch<ExtraHotelDataRecord>({
        isEnabled: hasExtraHotelData(hotel, unleash),
        url: `${publicRuntimeConfig.basePath}/api/extraHotelData/?${extraHotelDataQueryParams([hotel], unleash)}`,
    });

    if (error || !data) {
        return undefined;
    }

    return data[hotel.toLowerCase()];
};
